import React from "react"
import { IAnalysisFolder } from "../dashboardPage/components/fullAnalysis/IAnalysisFolder"
import { AnalysisProvider } from "../../api/fileProvider/analysisProvider"
import { FileProviderViewer } from "./FileProviderViewer"
import { GDriveConnectButton } from "./GDriveConnectButton"
import { FullAnalysisAddFolderPanelNew } from "../dashboardPage/components/fullAnalysis/FullAnalysisAddFolderPanel"

export const AnalysisViewer = ({onSelect, callModal}: {onSelect: (item: IAnalysisFolder)=>void, callModal: (modal: (close: ()=>void)=>React.ReactNode)=>void})=>{
    return <FileProviderViewer
        callModal={callModal}
        NotConnectedView={GDriveConnectButton}
        FileProvider={AnalysisProvider}
        onSelect={onSelect}
        AddPanel={FullAnalysisAddFolderPanelNew}
    ></FileProviderViewer>
}